import { ApiProvider } from '@restaurant/api-client/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/misc';
import { api } from '@/lib/api';
import { AuthProvider } from '@/lib/auth';
import { RealtimeProvider } from '@/lib/realtime';
import { applyTheme, storedTheme } from '@/lib/platform';
import { startUpdateChecks } from '@/lib/updater';
import { App } from './App';
import './index.css';

applyTheme(storedTheme());
matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => storedTheme() === 'system' && applyTheme('system'));

startUpdateChecks();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, refetchOnWindowFocus: true, retry: 1 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider api={api}>
        <AuthProvider>
          <RealtimeProvider>
            <TooltipProvider>
              <App />
              <Toaster richColors position="top-right" closeButton />
            </TooltipProvider>
          </RealtimeProvider>
        </AuthProvider>
      </ApiProvider>
    </QueryClientProvider>
  </StrictMode>,
);
